<template lang="pug">
  v-expansion-panel.refugio-panel(v-if="interfaceState.refugios")
    v-expansion-panel-content
      template(v-slot:header)
        .asu-title Referencias - Año {{refugiosYear}}
      v-list(dense)
        v-list-tile
          span.v-list__tile-text - Albergues
        v-list-tile(:key="`refugio-legend-item-${i}`" v-for="(item, i) in status")
          span.circle(:class="itemClass(item)")
          span.v-list__tile-text &nbsp;&nbsp;{{ item }}

</template>

<script>
import { mapGetters } from 'vuex'
import { refugioFilterObject } from '@/constants.js'
import { capitalize } from '@/utils/string-utils.js'

export default {
  data: () => ({
    status: refugioFilterObject.refugiosStatus
  }),
  methods: {
    itemClass (text) {
      const splited = text.split(' ')
      return `${splited[0]}${splited[1] ? capitalize(splited[1]) : ''}`
    }
  },
  computed: {
    ...mapGetters([
      'interfaceState',
      'refugiosYear'
    ])
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/refugios/variables'

$refugio-panel-width = $f250px

.refugio-panel
  color: $color_0
  position: absolute
  width: $refugio-panel-width
  top: auto
  left: $f80px
  bottom: $f70px
  z-index: 401
  @media screen and (max-width: 320px)
    left: 40px
    bottom: 5rem
  @media screen and (max-height: 780px) and (min-width: 321px)
    left: 72px
    bottom: 5rem
  & >>>
    .v-list--dense
      padding: 0 $f10px
      .v-list__tile
        height: $f30px
        padding: 0
        .v-list__tile-text
          font-size: $f14px
          color: $color_0

.asu-title
  font-size: $f17px
  font-weight: bold
  color: $color_0

.circle
  border-radius: 50%
  width: $f15px
  height: $f15px
  &.Censado
    background-color: $censadoColor
  &.NoCensado
    background-color: $noCensadoColor
  &.NoHabitable
    background-color: $noHabitableColor
  &.Afectadas
    background-color: $casasAfectadasColor

</style>
